var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { AuthService } from '../../modules/auth/auth.service';
var DashboardSidebarComponent = (function () {
    function DashboardSidebarComponent(auth) {
        this.auth = auth;
        jQuery('body').addClass('fixed-sidebar');
    }
    DashboardSidebarComponent.prototype.logout = function () {
        this.auth.logout();
    };
    DashboardSidebarComponent = __decorate([
        Component({
            selector: 'cx-dashboard-sidebar',
            templateUrl: './dashboard-sidebar.component.html',
        }),
        __metadata("design:paramtypes", [AuthService])
    ], DashboardSidebarComponent);
    return DashboardSidebarComponent;
}());
export { DashboardSidebarComponent };
//# sourceMappingURL=dashboard-sidebar.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/sidebar/dashboard-sidebar.component.js
// module id = 586
// module chunks = 0